import { ContactAddress } from './contact-address.model';
import { ContactPhone } from './contact-phone.model';
import { ContactEmail } from './contact-email.model';

export class ContactPoint {

    addresses: Array<ContactAddress>;
    emails: Array<ContactEmail>;
    phones: Array<ContactPhone>

    // constructor(addresses: Array<ContactAddress>,
    //     emails: Array<ContactEmail>,
    //     phones: Array<ContactPhone>) {
    //     this.addresses = addresses;
    //     this.emails = emails;
    //     this.phones = phones;
    // }

    constructor(address: ContactAddress,
        email: ContactEmail,
        phone: ContactPhone) {

        let addresses : Array<ContactAddress> = new Array();
        addresses.push(address);
        this.addresses = addresses;

        let emails : Array<ContactEmail> = new Array();
        emails.push(email);
        this.emails = emails;


        let phones : Array<ContactPhone> = new Array();
        phones.push(phone);
        this.phones = phones;
       
    }

}
